"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function resolvePackageUrlFactory(resolve, resolvePackageKey, sassUrlVariants) {
  return function (url, extensions, cwd, packageKeys) {
    var file = null;
    sassUrlVariants(url, extensions).some(function (urlVariant) {
      try {
        /* istanbul ignore next: resolve.sync is mocked anyway */
        var resolvedPath = resolve.sync(urlVariant, {
          basedir: cwd,
          packageFilter: function packageFilter(packageJson) {
            return resolvePackageKey(packageJson, packageKeys);
          },
          extensions: extensions
        });

        if (resolvedPath) {
          file = resolvedPath;
          return true;
        }
      } catch (e) {// Prevent the resolve module from throwing an
        // exception if no matching package is found.
      }

      return false;
    });
    return file;
  };
}

exports.resolvePackageUrlFactory = resolvePackageUrlFactory;